import React from 'react';

class Message extends React.PureComponent {

    render() {
        const { title, message, icon } = this.props;
        return (
            <span className="d-flex align-items-center justify-content-center">
                <i className={"fa-3x " + icon + " pr-3"}></i>
                <span>
                    {title &&
                        <span className="h5 d-block">{title}</span>
                    }
                    <span>{message}</span>
                </span>
            </span>
        );
    }
}

export default Message;